<div class="broker-login-page">
  <div class="login-card">
    <div class="brand-header">
      <span class="material-symbols-outlined brand-icon">handshake</span>
      <h1 class="brand-title">Weddingly Broker Portal</h1>
      <p class="brand-tagline">Manage marriage profiles in bulk and earn 15% wallet commission on every membership upgrade.</p>
    </div>

    <div class="tab-header">
      <button class="tab-btn" [class.active]="!isRegisterMode" (click)="isRegisterMode = false">Login</button>
      <button class="tab-btn" [class.active]="isRegisterMode" (click)="isRegisterMode = true">Register Agency</button>
    </div>

    <div *ngIf="error" class="alert-error">
      <span class="material-symbols-outlined">error</span> {{ error }}
    </div>

    <form (ngSubmit)="onSubmit()" class="login-form">
      <div *ngIf="isRegisterMode" class="form-group">
        <label>Full Name *</label>
        <input type="text" [(ngModel)]="name" name="name" placeholder="Enter your full name" class="form-input" required>
      </div>

      <div *ngIf="isRegisterMode" class="form-group">
        <label>Agency Name (optional if individual broker)</label>
        <input type="text" [(ngModel)]="agency_name" name="agency_name" placeholder="e.g. Sri Lakshmi Matrimony Bureau" class="form-input">
      </div>

      <div class="form-group">
        <label>Email Address *</label>
        <input type="email" [(ngModel)]="email" name="email" placeholder="broker@example.com" class="form-input" required>
      </div>

      <div *ngIf="isRegisterMode" class="form-group">
        <label>Mobile Number *</label>
        <input type="tel" [(ngModel)]="phone" name="phone" placeholder="e.g. 9876543210" class="form-input" required>
      </div>

      <div class="form-group">
        <label>Password *</label>
        <input type="password" [(ngModel)]="password" name="password" placeholder="••••••••" class="form-input" required>
      </div>

      <!-- Extended Tamil Nadu Agency Fields -->
      <div *ngIf="isRegisterMode" class="form-group">
        <label>City *</label>
        <input type="text" [(ngModel)]="city" name="city" placeholder="e.g. Madurai, Coimbatore, Chennai" class="form-input" required>
      </div>

      <div *ngIf="isRegisterMode" class="form-group">
        <label>Office Address *</label>
        <textarea [(ngModel)]="office_address" name="office_address" rows="2" placeholder="Enter your full office / bureau address" class="form-input" required style="resize: vertical;"></textarea>
      </div>

      <div *ngIf="isRegisterMode" style="display: flex; gap: 12px;">
        <div class="form-group" style="flex: 1;">
          <label>Years of Experience</label>
          <input type="number" [(ngModel)]="years_of_experience" name="years_of_experience" placeholder="e.g. 10" class="form-input">
        </div>
        <div class="form-group" style="flex: 1;">
          <label>Marriages Facilitated</label>
          <input type="number" [(ngModel)]="marriages_facilitated" name="marriages_facilitated" placeholder="Optional (e.g. 150)" class="form-input">
        </div>
      </div>

      <div *ngIf="isRegisterMode" class="form-group">
        <label>Selfie / Profile Photo</label>
        <input type="file" (change)="onPhotoSelected($event, false)" accept="image/*" class="form-input" style="padding: 6px;">
        <div *ngIf="profilePhotoPreview" style="margin-top: 6px;">
          <img [src]="profilePhotoPreview" style="width: 60px; height: 60px; object-fit: cover; border-radius: 6px; border: 1px solid #ccc;" alt="Profile Preview">
        </div>
      </div>

      <div *ngIf="isRegisterMode" class="form-group">
        <label>Aadhaar or PAN Photo <small style="color: #666; font-weight: normal;">(Optional for easy testing)</small></label>
        <input type="file" (change)="onPhotoSelected($event, true)" accept="image/*" class="form-input" style="padding: 6px;">
        <div *ngIf="idProofPreview" style="margin-top: 6px;">
          <img [src]="idProofPreview" style="width: 80px; height: 50px; object-fit: cover; border-radius: 4px; border: 1px solid #ccc;" alt="ID Preview">
        </div>
      </div>

      <div *ngIf="isRegisterMode" class="form-group">
        <label>UPI ID <small style="color: #666; font-weight: normal;">(Optional, can be added later in settings)</small></label>
        <input type="text" [(ngModel)]="upi_id" name="upi_id" placeholder="e.g. agency@okaxis" class="form-input">
      </div>

      <div *ngIf="isRegisterMode" class="form-group" style="display: flex; align-items: center; gap: 8px; margin-top: 8px;">
        <input type="checkbox" [(ngModel)]="agreed_to_terms" name="agreed_to_terms" id="terms_check" style="width: 18px; height: 18px; cursor: pointer;" required>
        <label for="terms_check" style="margin: 0; cursor: pointer; font-size: 13px;">I agree to Weddingly Matrimony Terms & Conditions and Agency Guidelines *</label>
      </div>

      <button type="submit" class="btn-submit" [disabled]="loading" style="margin-top: 12px;">
        <span class="material-symbols-outlined spin" *ngIf="loading">progress_activity</span>
        <span>{{ loading ? 'Processing...' : (isRegisterMode ? 'Submit Application for Review' : 'Sign In to Portal') }}</span>
      </button>
    </form>

    <div class="card-footer">
      <a routerLink="/" class="back-link"><span class="material-symbols-outlined">arrow_back</span> Return to Weddingly Main Site</a>
    </div>
  </div>
</div>

<!-- ═══════════════════════════════════════════════════════════════════
     OTP VERIFICATION MODAL FOR BROKER REGISTRATION
═══════════════════════════════════════════════════════════════════════ -->
<div class="otp-overlay" *ngIf="showOtpModal" (click)="closeOtpModal()">
  <div class="otp-modal" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="otp-modal-header">
      <div class="otp-modal-icon">
        <span class="material-symbols-outlined">{{ otpStep === 'channel' ? 'sms' : 'verified' }}</span>
      </div>
      <div>
        <h2 class="otp-modal-title">{{ otpStep === 'channel' ? 'Choose Verification Method' : 'Verify Your Number' }}</h2>
        <p class="otp-modal-sub" *ngIf="otpStep === 'channel'">
          We will send a 6-digit verification code to <strong>+91 {{ phone }}</strong>
        </p>
        <p class="otp-modal-sub" *ngIf="otpStep === 'verify'">
          We sent a 6-digit code via {{ otpChannel === 'whatsapp' ? 'WhatsApp' : 'SMS' }} to <strong>+91 {{ phone }}</strong>
        </p>
      </div>
      <button class="otp-close-btn" (click)="closeOtpModal()" title="Cancel">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>

    <!-- Channel Selector -->
    <div class="otp-channel-selector" *ngIf="otpStep === 'channel'">
      <button
        class="channel-btn"
        [class.channel-active]="otpChannel === 'sms'"
        (click)="selectChannel('sms')"
        [disabled]="otpSending">
        <span class="material-symbols-outlined">sms</span>
        SMS
      </button>
      <button
        class="channel-btn"
        [class.channel-active]="otpChannel === 'whatsapp'"
        (click)="selectChannel('whatsapp')"
        [disabled]="otpSending">
        <svg class="wa-icon" viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
        WhatsApp
      </button>
    </div>

    <!-- Sending Spinner -->
    <div class="otp-sending-wrap" *ngIf="otpSending">
      <span class="material-symbols-outlined otp-spin">progress_activity</span>
      <span>Sending OTP via {{ otpChannel === 'whatsapp' ? 'WhatsApp' : 'SMS' }}…</span>
    </div>

    <!-- STEP 1: Send OTP Button -->
    <button
      class="otp-verify-btn"
      (click)="sendOtp()"
      [disabled]="otpSending"
      *ngIf="otpStep === 'channel' && !otpSending">
      <span class="material-symbols-outlined">send</span>
      Send OTP via {{ otpChannel === 'whatsapp' ? 'WhatsApp' : 'SMS' }}
    </button>

    <!-- STEP 2: OTP Digits -->
    <div class="otp-digits-wrap" *ngIf="otpStep === 'verify' && !otpSending">
      <div class="otp-digits">
        <input
          *ngFor="let d of otpDigits; let i = index; trackBy: trackByIndex"
          [id]="'broker-otp-box-' + i"
          class="otp-digit"
          type="text"
          inputmode="numeric"
          maxlength="1"
          [value]="otpDigits[i]"
          (input)="onOtpInput($event, i)"
          (keydown)="onOtpKeydown($event, i)"
          (paste)="onOtpPaste($event)"
          autocomplete="one-time-code">
      </div>
      <p class="otp-expiry-note">
        <span class="material-symbols-outlined">schedule</span>
        Code expires in 5 minutes
      </p>
    </div>

    <!-- Error -->
    <div class="otp-error-msg" *ngIf="otpError">
      <span class="material-symbols-outlined">error</span>
      {{ otpError }}
    </div>

    <!-- STEP 2: Verify Button -->
    <button
      class="otp-verify-btn"
      (click)="verifyOtp()"
      [disabled]="!otpComplete || otpVerifying || otpSending"
      *ngIf="otpStep === 'verify' && !otpSending">
      <span class="material-symbols-outlined" [class.otp-spin]="otpVerifying">
        {{ otpVerifying ? 'progress_activity' : 'check_circle' }}
      </span>
      {{ otpVerifying ? 'Verifying…' : 'Verify & Submit Application' }}
    </button>

    <!-- STEP 2: Resend & Switch Row -->
    <div class="otp-resend-row" *ngIf="otpStep === 'verify' && !otpSending">
      <span *ngIf="resendSeconds > 0" class="otp-resend-timer">
        Resend in <strong>{{ resendSeconds }}s</strong>
      </span>
      <button
        *ngIf="resendSeconds === 0"
        class="otp-resend-btn"
        (click)="resendOtp()">
        <span class="material-symbols-outlined">refresh</span>
        Resend OTP
      </button>
      <span class="otp-divider" *ngIf="resendSeconds === 0">•</span>
      <button
        *ngIf="resendSeconds === 0"
        class="otp-switch-btn"
        (click)="switchChannelFromVerify()">
        Try via {{ otpChannel === 'sms' ? 'WhatsApp' : 'SMS' }} instead
      </button>
    </div>

  </div>
</div>
